<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
*{
  margin: 0 ;
  padding: 0 ;
}
.el-time-range-picker{
  width: 300px !important;
  left: 36px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue